import { Typography } from "@mui/material";
import {
  DetailsCardContainer,
  DetailsColumn,
  DetailsContainer,
  DetailsLabel,
  DetailsRow,
  DetailsText,
} from "../../constants/component.constants";
import { formatCurrency, formatDate, isNullUndefined } from "../../util/util";

export default function LeaseInfoCard(props) {
  const hasRentIncrement = !isNullUndefined(props?.selectedLease?.incrementPeriod);
  return (
    <DetailsCardContainer container spacing={1}>
      <DetailsRow>
        <Typography
          fontWeight={800}
          variant="h6"
          color="primary.dark"
          sx={{
            fontSize: "18px",
          }}
        >
          Lease Information for{" "}
          {props.selectedLease && props.selectedLease.contracteeName}
        </Typography>
      </DetailsRow>

      <DetailsContainer sx={{ width: "100%" }}>
        <DetailsColumn
          sx={{
            width: { lg: "25%", md: "100%", xs: "100%" },
          }}
        >
          <Typography
            fontWeight={800}
            variant="h6"
            color="primary.dark"
            sx={{
              textAlign: "start",
              marginBottom: "20px",
            }}
          >
            Lease Information
          </Typography>

          <DetailsRow>
            <DetailsLabel>Property Name</DetailsLabel>
            <DetailsText>
              {props.selectedLease && props.selectedLease.facilityName}
            </DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel>Units Leases</DetailsLabel>
            <DetailsText>
              {props.selectedLease && props.selectedLease.unitNames}
            </DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel>Lease Type</DetailsLabel>
            <DetailsText>
              {props.selectedLease && props.selectedLease.leaseType}
            </DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel>Lease Balance</DetailsLabel>
            <DetailsText>
              {props.selectedLease &&
                formatCurrency(props.selectedLease.leaseBalance)}
            </DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel>Rent Increment: </DetailsLabel>
            <DetailsText>
              {hasRentIncrement
                ? (props?.selectedLease?.incrementType == "Amount"
                    ? `Ksh ${formatCurrency(
                        props?.selectedLease?.rentIncrementAmount
                      )}`
                    : `${props?.selectedLease?.rentIncrementPercentage}%`) +
                  " every " +
                  props?.selectedLease?.incrementPeriod +
                  " year(s)"
                : "Not Applicable"}
            </DetailsText>
          </DetailsRow>
        </DetailsColumn>
        <DetailsColumn
          sx={{
            width: { lg: "20%", md: "100%", xs: "100%" },
          }}
        >
          <Typography
            fontWeight={800}
            variant="h6"
            color="primary.dark"
            sx={{
              textAlign: "start",
              marginBottom: "20px",
            }}
          >
            Lease Status
          </Typography>
          <DetailsRow>
            <DetailsLabel>Effective Date</DetailsLabel>
            <DetailsText>
              {props.selectedLease && isNullUndefined(props.selectedLease.start)
                ? "N/A"
                : formatDate(props.selectedLease.start)}
            </DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel>Expiration Date</DetailsLabel>
            <DetailsText>
              {props.selectedLease && isNullUndefined(props.selectedLease.end)
                ? "N/A"
                : formatDate(props.selectedLease.end)}
            </DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel>Status</DetailsLabel>
            <DetailsText>
              {props.selectedLease && props.selectedLease.status.name}
            </DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel>Has Revenue Sharing</DetailsLabel>
            <DetailsText>
              {props.selectedLease && props.selectedLease.hasRevenueSharing
                ? "Yes"
                : "No"}
            </DetailsText>
          </DetailsRow>
        </DetailsColumn>
        <DetailsColumn
          sx={{
            width: { lg: "30%", md: "100%", xs: "100%" },
          }}
        >
          <Typography
            fontWeight={800}
            variant="h6"
            color="primary.dark"
            sx={{
              textAlign: "start",
              marginBottom: "20px",
            }}
          >
            Tenant Details
          </Typography>
          <DetailsRow>
            <DetailsLabel>Tenant</DetailsLabel>
            <DetailsText>
              {props.selectedLease && props.selectedLease.contracteeName}
            </DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel>Email</DetailsLabel>
            <DetailsText sx={{ wordBreak: "break-word" }}>
              {props.selectedLease && props.selectedLease.tenant.email}
            </DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel>Phone</DetailsLabel>
            <DetailsText>
              {props.selectedLease && props.selectedLease.tenant.mobilePhone}
            </DetailsText>
          </DetailsRow>
          {props.selectedLease && props.selectedLease.tenant.contactNote && (
            <DetailsRow>
              <DetailsLabel>Contact Note</DetailsLabel>
              <DetailsText>
                {props.selectedLease.tenant.contactNote}
              </DetailsText>
            </DetailsRow>
          )}
        </DetailsColumn>
        <DetailsColumn
          sx={{
            width: { lg: "25%", md: "100%", xs: "100%" },
          }}
        >
          <Typography
            fontWeight={800}
            variant="h6"
            color="primary.dark"
            sx={{
              textAlign: "start",
              marginBottom: "20px",
            }}
          >
            Payment Information
          </Typography>
          <DetailsRow>
            <DetailsLabel>Billing Code</DetailsLabel>
            <DetailsText>
              {props.selectedLease && props.selectedLease.billingCode}
            </DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel>Rent Frequency</DetailsLabel>
            <DetailsText>
              {props.selectedLease && props.selectedLease.rentFrequency}
            </DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel>Periodic Charge</DetailsLabel>
            <DetailsText>
              {props.selectedLease &&
                formatCurrency(props.selectedLease.periodicCharge)}
            </DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel>
              {props.selectedLease?.hasRevenueSharing
                ? "Notification Day/Date"
                : "Rent Day/Date"}
            </DetailsLabel>
            <DetailsText>
              {(props.selectedLease?.rentDate &&
                formatDate(props.selectedLease.rentDate)) ||
                (props.selectedLease?.rentDay && props.selectedLease.rentDay) ||
                (props.selectedLease?.notificationDate &&
                  formatDate(props.selectedLease.notificationDate)) ||
                (props.selectedLease?.notificationDay &&
                  props.selectedLease.notificationDay)}
            </DetailsText>
          </DetailsRow>
        </DetailsColumn>
      </DetailsContainer>
    </DetailsCardContainer>
  );
}
